import React from 'react';
import { format } from 'date-fns';
import utcToZonedTime from 'date-fns-tz/utcToZonedTime';

import { useBuSettings, useMachineInfo } from 'common/pages/fleetV2/providers';
import { useFleetRouter } from 'common/pages/fleetV2/hooks/useFleetRouter';
import { getUserTimeZone, isUSTimeZone } from 'common/helpers/v1';
import { MachineStatusProps } from '../types';
import { useGetMachineStatusQuery } from 'common/pages/fleetV2/machine/dsi/api';
import { POLLING_INTERVAL } from '../utils';

export const useMachineStatusDSI = (): MachineStatusProps => {
  const { colors, Icons } = useBuSettings();
  const [{ id: machineId }] = useFleetRouter();
  const { timeZone } = useMachineInfo() as { timeZone: string };

  const { data, isLoading, hasError } = useGetMachineStatusQuery(
    {
      machineId: machineId as string
    },
    { pollingInterval: POLLING_INTERVAL }
  ) as {
    data: {
      connectionStatus?: string;
      latestDataReceived?: string;
      machineState?: string;
    };
    isLoading: boolean;
    hasError?: string;
  };

  const isUSA = isUSTimeZone(getUserTimeZone()); //Affects time formatting AM/PM vs 14:00
  const formattedDate =
    data?.latestDataReceived &&
    utcToZonedTime(data?.latestDataReceived.slice(0, 19) + '+00:00', timeZone);

  const time =
    data?.connectionStatus?.toLowerCase() === 'online'
      ? undefined
      : formattedDate &&
        data?.latestDataReceived &&
        (isUSA
          ? format(new Date(formattedDate), 'LL/dd/yy hh:mm:ss a')
          : format(new Date(formattedDate), 'dd/LL/yy HH:mm:ss'));

  return {
    color:
      data?.connectionStatus?.toLowerCase() === 'online'
        ? colors?.['online']
        : colors?.['disconnected'],
    status: data?.connectionStatus?.toLowerCase() === 'online' ? 'Connected' : 'Not Connected',
    Icon:
      data?.connectionStatus?.toLowerCase() === 'online'
        ? Icons?.['connected']
        : Icons?.['disconnected'],
    machineState: data?.machineState,
    timestamp: time,
    isLoading,
    hasError
  };
};
